<template>
  <base-step
    :title="trans('guided_search.installation_month.title')"
    :title-precision="trans('guided_search.extended_title.approximately')"
    main-class="installation-month-container"
  >
    <template #content>
      <div class="guided-search-content-form__installation">
        <div class="general-tags installation__tags">
          <TypeFormButton
            v-for="(tag, index) in tags"
            :key="index"
            :content="tag.text"
            :active="tag.active"
            @clicked="selectTag(tag)"
          />
        </div>
      </div>
    </template>
  </base-step>
</template>

<script>
import TypeFormButton from '@components-molecules/TypeFormButton.vue';
import { translationMixin } from '@elements/translation';
import { momentMixin } from '@tools/moment';
import { guidedSearchMixin } from '@pages/guided-search/guidedSearchMixin';
import BaseStep from './BaseStep.vue';

export default {
  components: { TypeFormButton, BaseStep },
  mixins: [ guidedSearchMixin, translationMixin, momentMixin ],
  data() {
    return {
      tags: [],
    };
  },
  computed: {
    getStepInstallationMonthValue() {
      return this.store.stepValues.installationMonth;
    },
    getToggleValue() {
      return this.getStepInstallationMonthValue === -1;
    },
  },
  mounted() {
    window.dataLayer.push({
      event: 'screenChange',
      event_name: 'startdate',
      step: 'startdate',
      funnel: 'support-contact-form',
    });
    this.generateTags();
  },
  methods: {
    generateTags() {
      const currentDate = new Date();
      const currentMonthIndex = currentDate.getMonth();
      const currentYear = currentDate.getFullYear();
      const maxMonth = 7;
      for (let i = 1; i <= maxMonth; i++) {
        const nextMonthIndex = (currentMonthIndex + i) % 12;
        const year = currentYear + Math.floor((currentMonthIndex + i) / 12);
        let text = `${this.trans(`global.month.${this.monthNamesList[nextMonthIndex]}`)} ${year}`;
        if (i === maxMonth) {
          text += ` ${this.trans('guided_search.installation_month.or_more')}`;
        }
        const month = this.trans(`global.month.${this.monthNamesList[nextMonthIndex]}`);
        this.tags.push(
          {
            month,
            active: false,
            year,
            text,
          },
        );
        // Here we check if there is, in the store, an active value
        if (year === this.getStepInstallationMonthValue?.year && month === this.getStepInstallationMonthValue?.month) {
          this.tags[this.tags.length - 1].active = true;
        }
      }
      this.tags.push({ text: this.trans('guided_search.toggle.i_dont_know'), active: this.getStepInstallationMonthValue === -1 });
    },
    onChangeMonth(newMonth) {
      this.store.setStepValue({ step: 'installationMonth', value: newMonth });
    },
    selectTag(tag) {
      const actualValue = this.getStepInstallationMonthValue;
      const previousValue = actualValue;
      let storeValue = null;
      if (actualValue) {
        const oldIndex = this.tags.findIndex((t) => t.year === actualValue.year && t.month === actualValue.month);
        this.tags[oldIndex].active = false;
      }
      if (actualValue !== tag.value) {
        const selectedIndex = this.tags.findIndex((t) => t.year === tag.year && t.month === tag.month);
        this.tags[selectedIndex].active = true;
        if (!tag.year && !tag.month) {
          storeValue = -1;
        }

        if (tag.month && tag.year) {
          storeValue = { month: tag.month, year: tag.year };
        }
      }
      this.store.setStepValue({
        step: 'installationMonth',
        value: storeValue,
      });

      if (previousValue?.year !== tag?.year || previousValue?.month !== tag?.month || !previousValue) {
        this.$emit('next-step');
        return;
      }
      this.store.setStepValue({
        step: 'installationMonth',
        value: null,
      });
      // eslint-disable-next-line no-param-reassign
      tag.active = false;
    },
  },
};
</script>
